import {
    ActionBtn, Label, ErrorMessageText, ErrorMessageDiv, LoaderDiv, FieldGroup, LoaderText, SecondaryButton, Divider
} from './styles';
import { IPresenterProps } from './types';
import CustomInput from '../../../components/Input/Container';
import Spinner from '../../../components/Spinner';
import COLORS from '../../../utils/Colors';
import { useHistory } from 'react-router-dom';

const LoginContainer = (props: IPresenterProps) => {
    const history = useHistory();

    const handleSignUp = () => {
        history.push('/signup');
    };

    return (
        <>
            <FieldGroup>
                <Label htmlFor="email">Correo Electrónico</Label>
                <CustomInput
                    inputType="email"
                    value={props.formData.email}
                    onChange={(e: any) => props.onChange(e, 'email')}
                    bgColor={COLORS.white}
                    disabled={props.emailDisabled}
                    showDeleteTextIcon={false}
                    deleteText={() => { }}
                    textColor={COLORS.black}
                    showError={false}
                />
            </FieldGroup>

            <FieldGroup>
                <Label htmlFor="password">Contraseña</Label>
                <CustomInput
                    inputType="password"
                    value={props.formData.password}
                    onChange={(e: any) => props.onChange(e, 'password')}
                    bgColor={COLORS.white}
                    disabled={props.passwordDisabled}
                    showDeleteTextIcon={false}
                    deleteText={() => { }}
                    textColor={COLORS.black}
                    showError={false}
                />
                <ErrorMessageDiv visible={props.errorMessage}>
                    <ErrorMessageText>
                        El correo y contraseña ingresados no coinciden con nuestros registros.
                    </ErrorMessageText>
                </ErrorMessageDiv>
            </FieldGroup>

            {props.loaderVisible ? (
                <LoaderDiv>
                    <Spinner size={40} color="#000000" thickness={3} />
                    <LoaderText>Autenticando...</LoaderText>
                </LoaderDiv>
            ) : (
                <>
                    <ActionBtn onClick={props.actionBtn} disabled={false}>
                        Iniciar Sesión
                    </ActionBtn>

                    <Divider>o</Divider>

                    <SecondaryButton onClick={handleSignUp} disabled={false}>
                        Crear Cuenta
                    </SecondaryButton>

                    <div onClick={() => props.changeStep(2)} style={{ marginTop: 24, cursor: 'pointer' }}>
                        <p style={{ textAlign: 'center', fontSize: 14, color: '#6b7280' }}>¿Olvidaste tu contraseña?</p>
                    </div>
                </>
            )}
        </>
    )
};

export default LoginContainer;
